export interface CompleteCategory {
  id: string;
  name: string;
  code: string;
  subcategories: string[];
}

export const ALL_AUTOMOTIVE_CATEGORIES: CompleteCategory[] = [
  {
    id: 'braking',
    name: 'Braking System',
    code: 'BRK',
    subcategories: [
      'Brake Pads',
      'Brake Rotors & Discs',
      'Brake Calipers',
      'Master Cylinders',
      'Brake Boosters',
      'Brake Lines & Hoses',
      'ABS Wheel Speed Sensors',
      'Brake Drum Assemblies'
    ]
  },
  {
    id: 'engine',
    name: 'Engine Components',
    code: 'ENG',
    subcategories: [
      'Timing Belt & Chain Kits',
      'Engine Mounts',
      'Gaskets & Seals',
      'Cylinder Heads',
      'Pistons & Rings',
      'Valves & Camshafts',
      'Oil Pumps',
      'Turbos & Superchargers'
    ]
  },
  {
    id: 'suspension',
    name: 'Suspension System',
    code: 'SUS',
    subcategories: [
      'Shock Absorbers & Struts',
      'Lower & Upper Control Arms',
      'Ball Joints',
      'Sway Bar Links',
      'Coil Springs',
      'Suspension Bushings',
      'Strut Mounts'
    ]
  },
  {
    id: 'steering',
    name: 'Steering System',
    code: 'STR',
    subcategories: [
      'Steering Racks & Pinions',
      'Power Steering Pumps',
      'Tie Rod Ends',
      'Steering Columns',
      'Steering Knuckles',
      'Power Steering Hoses'
    ]
  },
  {
    id: 'electrical',
    name: 'Electrical & Electronics',
    code: 'ELE',
    subcategories: [
      'Alternators & Regulators',
      'Starter Motors',
      'Car Batteries',
      'Engine Control Units (ECU)',
      'Wiring Harnesses',
      'Relays & Fuses',
      'Horns & Clocksprings'
    ]
  },
  {
    id: 'lighting',
    name: 'Lighting & Visibility',
    code: 'LGT',
    subcategories: [
      'Headlight Assemblies (LED/Xenon)',
      'Tail Light Assemblies',
      'Fog Light Lamps',
      'Indicators & Turn Signals',
      'Brake Lights',
      'Side Mirrors & Glass',
      'Wiper Blades & Motors'
    ]
  },
  {
    id: 'transmission',
    name: 'Transmission & Drivetrain',
    code: 'TRN',
    subcategories: [
      'Clutch Plate Kits & Flywheels',
      'CV Axles & Drive Shafts',
      'Automatic Gearboxes',
      'Manual Transmissions',
      'Differentials & Bearings',
      'Transmission Mounts',
      'Torque Converters'
    ]
  },
  {
    id: 'cooling',
    name: 'Engine Cooling',
    code: 'CLG',
    subcategories: [
      'Engine Radiators',
      'Water Pumps',
      'Engine Thermostats & Housings',
      'Radiator Cooling Fans',
      'Expansion Water Tanks',
      'Coolant Flanges & Hoses'
    ]
  },
  {
    id: 'hvac',
    name: 'Heating & AC (HVAC)',
    code: 'HVC',
    subcategories: [
      'AC Compressors & Clutches',
      'AC Condensers',
      'Evaporator Cores',
      'Blower Motors',
      'Heater Cores',
      'AC Expansion Valves',
      'Refrigerant Pressure Hoses'
    ]
  },
  {
    id: 'filtration',
    name: 'Filters & Service',
    code: 'FLT',
    subcategories: [
      'Engine Oil Filters',
      'Air Intake Filters',
      'Cabin Air Pollen Filters',
      'Fuel Filters',
      'Transmission Filters',
      'Service Kits'
    ]
  },
  {
    id: 'ignition',
    name: 'Ignition System',
    code: 'IGN',
    subcategories: [
      'Iridium Spark Plugs',
      'Ignition Coils & Packs',
      'Glow Plugs (Diesel)',
      'Distributors & Caps',
      'Spark Plug High Tension Wires'
    ]
  },
  {
    id: 'fuel',
    name: 'Fuel Supply & Injection',
    code: 'FUE',
    subcategories: [
      'Electric Fuel Pump Modules',
      'High-Pressure Fuel Injectors',
      'Fuel Tanks & Sending Units',
      'Fuel Pressure Regulators',
      'Throttle Bodies'
    ]
  },
  {
    id: 'exhaust',
    name: 'Exhaust & Emissions',
    code: 'EXH',
    subcategories: [
      'Catalytic Converters',
      'Exhaust Mufflers & Silencers',
      'Exhaust Manifolds',
      'Oxygen O2 Sensors',
      'DPF Diesel Particulate Filters',
      'Exhaust Resonators & Clamps'
    ]
  },
  {
    id: 'body',
    name: 'Body, Trim & Panels',
    code: 'BDY',
    subcategories: [
      'Front & Rear Bumpers',
      'Front Radiator Grilles',
      'Fenders & Quarter Panels',
      'Engine Bonnets & Hoods',
      'Vehicle Doors & Shells',
      'Door Handles & Window Regulators',
      'Trunk Lids & Tailgates'
    ]
  },
  {
    id: 'wheels',
    name: 'Wheels, Hubs & Bearings',
    code: 'WHL',
    subcategories: [
      'Wheel Bearing Kits',
      'Wheel Hub Assemblies',
      'Alloy Rims & Steel Wheels',
      'Tires',
      'Lug Nuts, Bolts & Studs',
      'TPMS Tire Pressure Sensors'
    ]
  },
  {
    id: 'interior',
    name: 'Cabin & Interior',
    code: 'INT',
    subcategories: [
      'Seats & Headrests',
      'Dashboards & Binnacles',
      'Airbags & Steering Wheels',
      'Center Consoles',
      'Window Switch Clusters',
      'Seat Belt Assemblies'
    ]
  },
  {
    id: 'hardware',
    name: 'Hardware & Fasteners',
    code: 'HDW',
    subcategories: [
      'Automotive Bolts & Screws',
      'Nuts & Washers',
      'Body Retaining Clips',
      'Mounting Brackets',
      'Sealing Rubber Grommets'
    ]
  },
  {
    id: 'ev',
    name: 'EV & Hybrid Powertrain',
    code: 'EVP',
    subcategories: [
      'High-Voltage Traction Batteries',
      'Electric Drive Motors',
      'Power Inverters & Converters',
      'On-Board Chargers',
      'High Voltage Cables & Ports',
      'Battery Management System (BMS)'
    ]
  },
  {
    id: 'adas',
    name: 'ADAS, Sensors & Vision',
    code: 'ADS',
    subcategories: [
      'Windshield ADAS Cameras',
      'Forward Radar Sensors',
      'Ultrasonic Parking Sensors',
      'Blind Spot Warning Radars',
      'LiDAR Modules',
      'Surround View Cameras'
    ]
  },
  {
    id: 'general',
    name: 'Fluids & Maintenance',
    code: 'FLU',
    subcategories: [
      'Synthetic Motor Oils',
      'DOT 4 & DOT 5.1 Brake Fluids',
      'Automatic & Manual Transmission Fluids',
      'Coolant & Antifreeze',
      'Power Steering Fluids',
      'Brake Cleaners & Degreasers'
    ]
  }
];
